import { PartState } from '../types';
import { curiousState } from './curious';

/**
 * Searching state — Bizy with squinted "scanning" eyes and her left arm raised
 * to shoulder height, like she's peering around looking for something.
 *
 * The arm stays outside the body bounds (x < 103) so no clip-path trick is needed.
 * Used during the pre-streaming waiting phase.
 */
export const searchingState: PartState = {
	antenna1: curiousState.antenna1,
	antenna2: curiousState.antenna2,
	body: curiousState.body,
	bodyHighlight: curiousState.bodyHighlight,
	stripes: curiousState.stripes,
	stinger: curiousState.stinger,
	badge: curiousState.badge,
	wing1Path: curiousState.wing1Path,
	wing2Path: curiousState.wing2Path,
	wing3Path: curiousState.wing3Path,
	wing4Path: curiousState.wing4Path,
	// Squinted eyes — top of eye lowered to convey looking-into-the-distance
	eyes: {
		leftPath:
			'M114 103C114 100 116.462 98 119.5 98C122.538 98 125 100 125 103C125 103 125 107.5 125 107.5C125 110.538 122.538 113 120 113C119.5 113 119.5 113 119 113C116.462 113 114 110.538 114 107.5C114 107.5 114 103 114 103Z',
		rightPath:
			'M153 103C153 100 155.462 98 158.5 98C161.538 98 164 100 164 103C164 103 164 107.5 164 107.5C164 110.538 161.538 113 159 113C158.5 113 158.5 113 158 113C155.462 113 153 110.538 153 107.5C153 107.5 153 103 153 103Z',
	},
	arms: [
		// Left arm raised to shoulder height — stays fully outside body (x < 103)
		{ d: 'M107.22 139.00L102 118C101.3 112 100.5 106 99.8 100L94 91', side: 'left' },
		// Right arm hanging naturally (same as curious)
		{
			d: curiousState.arms.find((a) => a.side === 'right')?.d ?? 'M201.62 140.17L207.62 167.80C207.81 168.68 208.21 169.50 208.78 170.20L218.00 180.87',
			side: 'right',
		},
	],
};
